import React from "react";
import { Helmet } from "react-helmet";
import { blogData } from "../../blogs";
import BlogCarausel from "./BlogCarausel";
import BlogHelmet from "./BlogHelmet";
import { Link } from "react-router-dom";
import {
  BlogHeading,
  BlogImage,
  BlogLi,
  BlogList,
  BlogSubHeading,
  BlogText,
  BlogWrapper,
} from "./blogs.styled";
import TopicNavigation from "./TopicNavigation";
const Mar4 = ({ index }) => {
  return (
    <div className="container" style={{ paddingTop: "9vh" }}>
      <BlogHelmet b={blogData[index]} />
      <BlogWrapper>
        <BlogText style={{ fontWeight: "bold" }}>{blogData[index].date}</BlogText>
        <TopicNavigation index={index} />

        <BlogHeading style={{ color: "rgba(229, 61, 84, 1)" }}>{blogData[index].title}</BlogHeading>
        <BlogSubHeading>What is Role-Based Access Control (RBAC)?</BlogSubHeading>

        <BlogText>
          TRole-based Access Control Management is a system through which a company’s management can
          control access or restrict certain area or information depending upon the position of the
          employee in a company or his/her work profile.
          <br />
          Under this form of
          <Link to="/blog/contactless-access-control-system-advantages">
            {" "}
            access control management{" "}
          </Link>
          , an employees’ position in the company determines which information must be shared with them.
          <br />
          Since some information must be kept only to senior management and in certain specific sectors
          like health care organization, financial institutions, the management also have to restrict
          entrance to data rooms, vaults, locker room, meeting rooms etc. as such access must be allowed
          to certain people only.
        </BlogText>
        <BlogImage src={blogData[index].imgSrc} alt={blogData[index].imgSrcAlt} />
        <BlogSubHeading>
          Roles may be categorized according to tasks they need to carry out, like: -
        </BlogSubHeading>

        <BlogList>
          <BlogLi>Technical – access to only the technical team</BlogLi>
          <BlogLi>Administrative – administration concerned only</BlogLi>
          <BlogLi>Security – access to only persons responsible.</BlogLi>
        </BlogList>
        <BlogSubHeading>Uses of Role-based Access Control System Management:-</BlogSubHeading>

        <BlogList>
          <BlogLi>
            Bank or financial sector – vaults, locker rooms and data rooms must be well protected to
            ensure safety
          </BlogLi>
          <BlogLi>Storage rooms in hotels, hostels, offices, & warehouses</BlogLi>
          <BlogLi>
            <Link to="/blog/residents-safety-apartments"> Commercial/Residential Apartments </Link>– To
            allow entry of only known individuals, thus ensuring the safety of people living in the
            society.
          </BlogLi>
          <BlogLi>
            Ease for Visitors – in offices or even in apartments, with RBAC, it is much easier and faster
            to just enter OTP for entrance.
          </BlogLi>
        </BlogList>
        <BlogImage src={blogData[index].img2} alt={blogData[index].img2Alt} />
        <BlogSubHeading>Advantages of Role-based Access Control Solution Management:-</BlogSubHeading>

        <BlogList>
          <BlogLi>
            <span className="font-weight-bold">Improves Work Efficiency:-</span> Using RBAC makes it much
            easier for office management to change access according to change in the role of office
            staff. This is much more convenient to do rather than administering every entry and exit and
            approving every time.
          </BlogLi>
          <BlogLi>
            <span className="font-weight-bold">Security Against any Inside Information Leak:-</span> As
            the access to certain information or room will only be given to a certain set of people
            responsible and trusted, it reduces any type of leakage of confidential information or even
            entry of any unwanted individual.
          </BlogLi>
          <BlogLi>
            <span className="font-weight-bold">Time-Saving:-</span> Under RBAC Management, one would only
            require a card or password (according to system functionality) to get access to any
            information/room. This is contrary to prior methods wherein security officials use to ask and
            confirm ones’ credentials and then that person would be allowed to enter after everything
            seems fine, which is very time-consuming.
          </BlogLi>
          <BlogLi>
            <span className="font-weight-bold">Helps to Keep Record:-</span> RBAC system not only just
            ensures safety but, also records data of entries and exits which makes it easy to analyze
            work hours as well.
          </BlogLi>
        </BlogList>
        <BlogImage src={blogData[index].img3} alt={blogData[index].img3Alt} />

        <BlogSubHeading>Disadvantages of Role-based Access Control Solution Management:-</BlogSubHeading>

        <BlogList>
          <BlogLi>
            <span className="font-weight-bold">Complex For Large-Scale Organization: </span> In a large
            organization, thousands of employees work in different roles. Managing access for a large
            number of employees is difficult with RBAC.
          </BlogLi>
          <BlogLi>
            <span className="font-weight-bold">Management Limited to Role: </span> Under RBAC management,
            restrictions can be fixed based only on the role of individuals and not the operations
            performed by them.
          </BlogLi>
        </BlogList>
        <BlogImage src={blogData[index].img4} alt={blogData[index].img4Alt} />
        <BlogText>
          Implementing RBAC in an organization requires detailed analysis and consideration before the
          final implementation. Once this analysis is done, setting up of RBAC system can become a
          simpler process.
          <br />
          With RBAC, organizations can ensure the safety of specific areas and information up-to a great
          extent. In modern organizations, RBAC is a proven way to manage safety requirements at the
          workplace.
        </BlogText>
      </BlogWrapper>
      <BlogCarausel prev={blogData[index - 1]} next={blogData[index + 1]} />
    </div>
  );
};

export default Mar4;
